import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Shield, ArrowLeft } from 'lucide-react';

const Section = ({ title, children }) => (
  <div style={{ marginBottom: 28 }}>
    <h2 style={{ fontSize: 16, fontWeight: 700, color: '#00F0FF', marginBottom: 10, fontFamily: 'var(--font-heading)' }}>{title}</h2>
    <div style={{ fontSize: 14, color: '#B0B8D0', lineHeight: 1.8 }}>{children}</div>
  </div>
);

const TermsPage = () => {
  const navigate = useNavigate();
  return (
    <div style={{ minHeight: '100vh', background: '#020210', padding: '0 0 60px' }}>
      {/* Navbar */}
      <nav style={{
        background: 'rgba(2,2,16,0.95)', backdropFilter: 'blur(12px)',
        borderBottom: '1px solid rgba(112,0,255,0.3)',
        padding: '0 24px', height: 56,
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        position: 'sticky', top: 0, zIndex: 50,
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer' }} onClick={() => navigate('/')}>
          <Shield size={22} color="#00F0FF" />
          <span style={{ fontWeight: 800, fontSize: 18, color: '#fff' }}>Web<span style={{ color: '#00F0FF' }}>Shield</span></span>
        </div>
        <button onClick={() => navigate(-1)} style={{
          background: 'transparent', border: '1px solid #2a2a4a', borderRadius: 8,
          padding: '6px 14px', color: '#b0b8d0', fontSize: 13, cursor: 'pointer',
          display: 'flex', alignItems: 'center', gap: 6,
        }}>
          <ArrowLeft size={14} /> Back
        </button>
      </nav>

      <div style={{ maxWidth: 720, margin: '0 auto', padding: '40px 24px' }}>
        <h1 style={{ fontSize: 28, fontWeight: 800, color: '#fff', marginBottom: 6, fontFamily: 'var(--font-heading)' }}>
          Terms of Service
        </h1>
        <p style={{ color: '#6a7a9a', fontSize: 13, marginBottom: 36 }}>Last updated: April 2026</p>

        <Section title="1. Acceptance of terms">
          By using WebShield at <span style={{ color: '#00F0FF' }}>webshield.app</span>, you agree to these Terms of Service. If you do not agree, please do not use the service.
        </Section>

        <Section title="2. Description of service">
          WebShield provides automated website security scanning. For a one-time fee of ₹299, we perform 8 security checks on a URL you provide and deliver a PDF report to your email address. The scan analyses publicly accessible information only — no intrusive or destructive testing is performed.
        </Section>

        <Section title="3. Permitted use">
          <p style={{ marginBottom: 8 }}>You may only submit URLs that you:</p>
          <ul style={{ paddingLeft: 20, margin: 0 }}>
            <li style={{ marginBottom: 6 }}>Own or operate.</li>
            <li style={{ marginBottom: 6 }}>Have explicit written permission to test.</li>
          </ul>
          <p style={{ marginTop: 10 }}>You must <strong style={{ color: '#FF0055' }}>not</strong> use WebShield to scan websites without authorisation. Doing so may violate applicable computer crime laws. We reserve the right to refuse or cancel any scan we suspect is unauthorised.</p>
        </Section>

        <Section title="4. Payment and refunds">
          <ul style={{ paddingLeft: 20, margin: 0 }}>
            <li style={{ marginBottom: 6 }}>Payment is a one-time charge of ₹299 processed by Razorpay.</li>
            <li style={{ marginBottom: 6 }}>Scans begin immediately after payment is confirmed.</li>
            <li style={{ marginBottom: 6 }}>Refunds are available if the scan fails to complete due to a technical error on our side. Contact <a href="mailto:support@webshield.app" style={{ color: '#00F0FF' }}>support@webshield.app</a> within 7 days.</li>
            <li style={{ marginBottom: 6 }}>No refunds for completed scans where results were delivered successfully.</li>
          </ul>
        </Section>

        <Section title="5. Accuracy and limitations">
          WebShield performs automated checks and the results reflect the state of the target website at the time of the scan. We do not guarantee that the scan will detect every vulnerability. The report is intended as a guide — not a comprehensive security audit. We recommend consulting a qualified security professional for critical systems.
        </Section>

        <Section title="6. Intellectual property">
          The PDF report generated is for your personal or business use. You may share it freely. The WebShield platform, brand, and underlying technology remain our intellectual property.
        </Section>

        <Section title="7. Limitation of liability">
          WebShield is provided "as is". To the maximum extent permitted by law, we are not liable for any direct, indirect, or consequential damages arising from use of the service, including but not limited to reliance on scan results, missed vulnerabilities, or service downtime.
        </Section>

        <Section title="8. Prohibited actions">
          <ul style={{ paddingLeft: 20, margin: 0 }}>
            <li style={{ marginBottom: 6 }}>Scanning third-party websites without authorisation.</li>
            <li style={{ marginBottom: 6 }}>Attempting to reverse engineer, scrape, or abuse the API.</li>
            <li style={{ marginBottom: 6 }}>Using automated scripts to submit large numbers of scans.</li>
            <li style={{ marginBottom: 6 }}>Reselling scan reports as your own product without agreement.</li>
          </ul>
        </Section>

        <Section title="9. Governing law">
          These terms are governed by the laws of India. Any disputes are subject to the exclusive jurisdiction of courts in Pune, Maharashtra, India.
        </Section>

        <Section title="10. Contact">
          Questions about these terms? Email us at <a href="mailto:webshieldapp@gmail.com" style={{ color: '#00F0FF' }}>webshieldapp@gmail.com</a>.
        </Section>
      </div>
    </div>
  );
};

export default TermsPage;